import { EventModel } from '@/models/event.model';
import { cloneDeep } from 'lodash';
import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { DataResponse } from '@/models/data-response.model';

interface LoadingState {
  singleCourse: EventModel | null;
  singleCourseChildren: EventModel[];
  singleCourseIncludedArray: any[];
}

export const defaultSingleCourseState: LoadingState = {
  singleCourse: null,
  singleCourseChildren: [],
  singleCourseIncludedArray: []
};

const state: LoadingState = cloneDeep(defaultSingleCourseState);

const mutations: MutationTree<LoadingState> = {
  ADD_SINGLE_COURSE(returnedState: LoadingState, payload: { course: EventModel; includedArray: any[] }): void {
    returnedState.singleCourse = payload.course;
    returnedState.singleCourseIncludedArray = payload.includedArray;
  },
  ADD_SINGLE_COURSE_CHILDREN(returnedState: LoadingState, payload: DataResponse<EventModel>): void {
    returnedState.singleCourseChildren = payload.data;
  },
  REMOVE_SINGLE_COURSE(returnedState: LoadingState): void {
    returnedState.singleCourse = null;
    returnedState.singleCourseIncludedArray = [];
  },
  REMOVE_SINGLE_COURSE_CHILDREN(returnedState: LoadingState): void {
    returnedState.singleCourseChildren = [];
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addSingleCourse: (
    { commit }: ActionContext<LoadingState, {}>,
    payload: { course: EventModel; includedArray: any[] }
  ): void => {
    commit('ADD_SINGLE_COURSE', payload);
  },
  addSingleCourseChildren: ({ commit }: ActionContext<LoadingState, {}>, payload: DataResponse<EventModel>): void => {
    commit('ADD_SINGLE_COURSE_CHILDREN', payload);
    window?.dispatchEvent?.(new Event('resize'));
  },
  removeSingleCourse: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('REMOVE_SINGLE_COURSE');
    commit('REMOVE_SINGLE_COURSE_CHILDREN');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  singleCourse: (returnedState: LoadingState): EventModel | null => {
    return returnedState.singleCourse;
  },
  singleCourseChildren: (returnedState: LoadingState): EventModel[] | [] => {
    return returnedState.singleCourseChildren ?? [];
  },
  sincleCourseIncludedArray: (returnedState: LoadingState): any[] => {
    return returnedState.singleCourseIncludedArray;
  },
  isFreeCourse: (returnedState: LoadingState): boolean => {
    if (returnedState.singleCourse) {
      return !returnedState.singleCourse.attributes.cost;
    }

    return false;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
